import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Fade,
  Stack,
  Typography,
} from "@mui/material";

export default function SalesImportDiscardDialog({
  open,
  mode = "exit",
  loading = false,
  error = "",
  onClose,
  onConfirm,
  onForceExit,
}) {
  const removing = mode === "remove";
  const title = removing ? "Quitar archivo" : "Cancelar importación";
  const titleId = "sales-import-discard-dialog-title";

  return (
    <Dialog
      open={Boolean(open)}
      aria-labelledby={titleId}
      onClose={loading ? undefined : onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      PaperProps={{ sx: { bgcolor: "transparent", boxShadow: "none", borderRadius: "30px", overflow: "visible" } }}
      slotProps={{
        backdrop: { timeout: 180, sx: { bgcolor: "rgba(2, 8, 23, 0.45)", backdropFilter: "blur(3px)" } },
      }}
    >
      <Fade in={Boolean(open)} timeout={180}>
        <Box
          sx={{
            width: "min(92vw, 560px)",
            bgcolor: "neutral.500",
            borderRadius: "32px",
            p: { xs: 2.5, sm: 3.5 },
            boxShadow: "0px 20px 60px rgba(0,0,0,.28)",
          }}
        >
          <Stack spacing={2.5} sx={{ alignItems: "center" }}>
            <Box sx={{ px: 3, py: 1.2, bgcolor: "secondary.50", borderRadius: "33px", boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)" }}>
              <Typography
                id={titleId}
                sx={{ color: "primary.900", fontSize: 19, fontWeight: 800 }}
              >
                {title}
              </Typography>
            </Box>
            <Box sx={{ width: "100%", p: { xs: 2.25, sm: 2.75 }, borderRadius: "22px", bgcolor: "neutral.50", boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.5)" }}>
              <Typography sx={{ color: "primary.900", fontSize: 17, fontWeight: 700 }}>
                {removing
                  ? "¿Querés quitar el archivo y eliminar el borrador actual?"
                  : "¿Querés salir y cancelar el borrador de ventas?"}
              </Typography>
              <Typography sx={{ mt: 0.8, color: "neutral.700", fontSize: 13, fontWeight: 700 }}>
                El archivo y los datos verificados dejarán de estar disponibles.
              </Typography>
              {error ? (
                <Box role="alert" sx={{ mt: 2, px: 1.5, py: 1.1, borderRadius: "14px", bgcolor: "secondary.700" }}>
                  <Typography sx={{ color: "logoblanco", fontSize: 12, fontWeight: 700 }}>{error}</Typography>
                  <Typography sx={{ mt: 0.4, color: "logoblanco", fontSize: 11, fontWeight: 600 }}>
                    {removing
                      ? "El borrador sigue disponible y podés volver a intentar eliminarlo."
                      : "Si salís, el backend eliminará el borrador cuando expire."}
                  </Typography>
                </Box>
              ) : null}
            </Box>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ width: "100%", justifyContent: "flex-end" }}>
              <Button
                type="button"
                disabled={loading}
                onClick={onClose}
                variant="contained"
                sx={{ px: 3, minHeight: 44, borderRadius: "33px", bgcolor: "secondary.50", color: "primary.900", textTransform: "none", fontWeight: 800, fontSize: 15, boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)", "&:hover": { bgcolor: "secondary.100" } }}
              >
                Seguir importando
              </Button>
              {error && !removing ? (
                <Button type="button" disabled={loading} onClick={onForceExit} sx={{ color: "logoblanco", textTransform: "none", fontWeight: 800 }}>
                  Salir de todos modos
                </Button>
              ) : null}
              <Button
                type="button"
                variant="contained"
                disabled={loading}
                onClick={onConfirm}
                startIcon={loading ? <CircularProgress size={15} color="inherit" /> : <DeleteOutlineIcon sx={{ fontSize: 18 }} />}
                sx={{ px: 3, minHeight: 44, borderRadius: "33px", bgcolor: "secondary.500", color: "logoblanco", textTransform: "none", fontSize: 15, fontWeight: 800, boxShadow: "0px 8px 20px rgba(76, 72, 141, 0.24)", "&:hover": { bgcolor: "secondary.600" } }}
              >
                {loading ? "Eliminando..." : title}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Dialog>
  );
}
